import { Button, DialogActions } from "@mui/material"
import { useOkCancelContext } from "lib/@hooks/useOkCancelContext"
import Iconify from "minimals-template/components/Iconify"

export function TaskComparisonRestoreActions({ isHeader = false } = {}) {
    const { ok, cancel } = useOkCancelContext()
    const label = isHeader ? "Restore Deleted Header" : "Restore Task"

    return (
        <DialogActions>
            <Button onClick={cancel} color="inherit">
                Close
            </Button>
            <Button
                variant="contained"
                onClick={handleRestore}
                startIcon={<Iconify icon="mdi:delete-restore" />}
                data-cy="restore-deleted-task-button"
            >
                {label}
            </Button>
        </DialogActions>
    )

    function handleRestore() {
        ok({ restore: true })
    }
}
